import $ from 'jquery'
import { prepareChessboard, restrictMove, validateMove, loadNextConfiguration, showMagnus } from '../../utils';
import { BLACK_PIECE_SEARCH_KEY, WHITE_INITIAL_MOVE, CORRECT_ANSWER_AUDIO, WRONG_ANSWER_AUDIO, WHITE_PIECE_SEARCH_KEY, BLACK_INITIAL_MOVE } from '../../utils/constants';
import ChessBoard from '../../components/chessBoard';
/**
* @name lesson13Assignment1
* @function
* @param {config}
* @description: activity related task
*/
export function lesson13Activity1(config) {
    let position = config.position,
        next = config.next,
        count = 2,
        allCoordinates = new Set();

    let afterLoad = function () {
        prepareChessboard(config);
        $(function () {
            $('#chessBoard').addClass('custom-background-image-5x5');
            $('.row-5277c:nth-child(-n+3)').css('display', 'none');
            $('.row-5277c .square-55d63:nth-last-child(-n+4)').css('display', 'none');
        })
    }

    let onDragStart = function (source, piece, position, orientation) {
        return restrictMove(piece, BLACK_PIECE_SEARCH_KEY);
    }

    let onDrop = function (source, target, piece, newPos, oldPos, orientation) {
        return validateMove(source, target, piece, false);
    }

    var onSnapEnd = function (source, target, piece) {
        $('.square-' + source).prepend('<img class="star-icon" src="/img/star.png" />');
        let boardFen = ChessBoard.board.fen();
        if (allCoordinates.has(target)) {
            --count;
            if (count < 1) {
                showMagnus({
                    data: `Don't worry, it's tough.`,
                    position: 'left',
                    styleClass: 'md'
                })
                count = 2;
                allCoordinates.clear();
                loadNextConfiguration(2000, next, false);
            } else {
                showMagnus({
                    data: `Oops! Try again. You have ${count} more try!`,
                    position: 'left',
                    styleClass: 'md'
                })
                setTimeout(function () {
                    $('.star-icon').remove();
                    allCoordinates.clear();
                    ChessBoard.board.position(position);
                    ChessBoard.game = new window.Chess(position + WHITE_INITIAL_MOVE);
                    return 'snapback'
                }, 2000);
            }
        } else {
            $(document).trigger('audio-play', CORRECT_ANSWER_AUDIO);
            allCoordinates.add(source);
            if (allCoordinates.size >= 24) {
                showMagnus({
                    data: 'Wow! You did it.',
                    position: 'left',
                    styleClass: 'xs'
                })
                count = 2;
                allCoordinates.clear();
                loadNextConfiguration(3000, config.next, true);
            } else {
                let msg = `Looks like you are stuck! Try again.`;
                if (target === 'a5' && allCoordinates.has('b3') && allCoordinates.has('c4')) {
                } else if (target === 'e5' && allCoordinates.has('c4') && allCoordinates.has('d3')) {
                } else if (target === 'e1' && allCoordinates.has('c2') && allCoordinates.has('d3')) {
                } else if (target === 'a4' && allCoordinates.has('b2') && allCoordinates.has('c3') && allCoordinates.has('c5')) {
                } else if (target === 'e4' && allCoordinates.has('d2') && allCoordinates.has('c3') && allCoordinates.has('c5')) {
                } else if (target === 'a3' && allCoordinates.has('b1') && allCoordinates.has('b5') && allCoordinates.has('c2') && allCoordinates.has('c4')) {
                } else if (target === 'e3' && allCoordinates.has('c2') && allCoordinates.has('c4') && allCoordinates.has('d1') && allCoordinates.has('d5')) {
                } else if (target === 'a2' && allCoordinates.has('b4') && allCoordinates.has('c1') && allCoordinates.has('c3')) {
                } else if (target === 'e2' && allCoordinates.has('c1') && allCoordinates.has('c3') && allCoordinates.has('d4')) {
                } else if (target === 'b5' && allCoordinates.has('a3') && allCoordinates.has('c3') && allCoordinates.has('d4')) {
                } else if (target === 'd5' && allCoordinates.has('b4') && allCoordinates.has('c3') && allCoordinates.has('e3')) {
                } else if (target === 'b4' && allCoordinates.has('a2') && allCoordinates.has('c2') && allCoordinates.has('d3') && allCoordinates.has('d5')) {
                } else if (target === 'd4' && allCoordinates.has('b3') && allCoordinates.has('b5') && allCoordinates.has('c2') && allCoordinates.has('e2')) {
                } else if (target === 'b3' && allCoordinates.has('a5') && allCoordinates.has('c1') && allCoordinates.has('c5') && allCoordinates.has('d2') && allCoordinates.has('d4')) {
                } else if (target === 'd3' && allCoordinates.has('b2') && allCoordinates.has('b4') && allCoordinates.has('c1') && allCoordinates.has('c5') && allCoordinates.has('e1') && allCoordinates.has('e5')) {
                } else if (target === 'b2' && allCoordinates.has('a4') && allCoordinates.has('c4') && allCoordinates.has('d1') && allCoordinates.has('d3')) {
                } else if (target === 'd2' && allCoordinates.has('b1') && allCoordinates.has('b3') && allCoordinates.has('c4') && allCoordinates.has('e4')) {
                } else if (target === 'b1' && allCoordinates.has('a3') && allCoordinates.has('c3') && allCoordinates.has('d2')) {
                } else if (target === 'd1' && allCoordinates.has('b2') && allCoordinates.has('c3') && allCoordinates.has('e3')) {
                } else if (target === 'c5' && allCoordinates.has('a4') && allCoordinates.has('b3') && allCoordinates.has('d3') && allCoordinates.has('e4')) {
                } else if (target === 'c4' && allCoordinates.has('a3') && allCoordinates.has('a5') && allCoordinates.has('b2') && allCoordinates.has('d2') && allCoordinates.has('e3') && allCoordinates.has('e5')) {
                } else if (target === 'c3' && allCoordinates.has('a2') && allCoordinates.has('a4') && allCoordinates.has('b1') && allCoordinates.has('b5') && allCoordinates.has('d1') && allCoordinates.has('d5') && allCoordinates.has('e2') && allCoordinates.has('e4')) {
                } else if (target === 'c2' && allCoordinates.has('a3') && allCoordinates.has('b4') && allCoordinates.has('d4') && allCoordinates.has('e1') && allCoordinates.has('e3')) {
                } else if (target === 'c1' && allCoordinates.has('a2') && allCoordinates.has('b3') && allCoordinates.has('d3') && allCoordinates.has('e2')) {
                } else {
                    msg = ``
                }
                if (msg) {
                    --count;
                    if (count < 1) {
                        showMagnus({
                            data: `That's okay, it's harder than it looks.`,
                            position: 'left',
                            styleClass: 'md'
                        })
                        count = 2;
                        allCoordinates.clear();
                        loadNextConfiguration(4000, next, false);
                    } else {
                        showMagnus({
                            data: msg + 'You have ' + count + ' more try!',
                            position: 'left',
                            styleClass: 'lg'
                        })
                        setTimeout(function () {
                            $('.star-icon').remove();
                            allCoordinates.clear();
                            $(document).trigger('bubble-hide');
                            ChessBoard.board.position(position);
                            ChessBoard.game = new window.Chess(position + WHITE_INITIAL_MOVE);
                            return 'snapback'
                        }, 4000);
                    }
                }
            }
        }
        ChessBoard.game = new window.Chess(boardFen + WHITE_INITIAL_MOVE);
    }

    const chessConfig = {
        config: {
            sparePieces: true,
            position: position,
            onDragStart: onDragStart,
            onDrop: onDrop,
            onSnapEnd: onSnapEnd,
            draggable: true
        },
        afterLoad: afterLoad
    }
    return chessConfig;
}

/**
 * @name lesson13Activity2
 * @function
 * @param { config }
 * @description: Complete the Knight's tour
 */

export function lesson13Activity2(config) {
    let position = config.position,
        next = config.next,
        boardFen = position,
        highlightCoordinates = new Set(['a1', 'a2', 'a3', 'a5', 'b2', 'b3', 'b4', 'b5', 'c1', 'c2', 'c4', 'd1', 'd3', 'd4', 'd5', 'e1', 'e2', 'e3', 'e5']);

    let afterLoad = function () {
        prepareChessboard(config);
        $(function () {
            $('#chessBoard').addClass('custom-background-image-5x5');
            $('.row-5277c:nth-child(-n+3)').css('display', 'none');
            $('.row-5277c .square-55d63:nth-last-child(-n+4)').css('display', 'none');
            highlightCoordinates.forEach(function (element) {
                $('.square-' + element).prepend('<img class="star-icon" src="/img/star.png" />');
            })
        });
    }

    let onDragStart = function (source, piece, position, orientation) {
        return restrictMove(piece, WHITE_PIECE_SEARCH_KEY);
    }

    let onDrop = function (source, target, piece, newPos, oldPos, orientation) {
        return validateMove(source, target, piece, false);
    }

    var onSnapEnd = function (source, target, piece) {
        if ((source === 'a4' && target === 'c5') || (source === 'c5' && target === 'e4')
            || (source === 'e4' && target === 'd2') || (source === 'd2' && target === 'b1')
            || (source === 'b1' && target === 'c3')) {
            $('.square-' + source).prepend('<img class="star-icon" src="/img/star.png" />');
            $(document).trigger('audio-play', CORRECT_ANSWER_AUDIO);
            boardFen = ChessBoard.board.fen();
            if (boardFen === '8/8/8/8/8/2n5/8/8') {
                showMagnus({
                    data: `Well done!`,
                    position: 'left',
                    styleClass: 'xs'
                })
                setTimeout(function () {
                    loadNextConfiguration(2000, next, true);
                }, 1000);
            }
            ChessBoard.game = new window.Chess(boardFen + BLACK_INITIAL_MOVE);
        } else if ((source === 'a4' && target === 'c3') || (source === 'e4' && target === 'c3')) {
            $(document).trigger('audio-play', WRONG_ANSWER_AUDIO);
            showMagnus({
                data: 'This move will not complete the Knight\'s tour on c3',
                position: 'left',
                styleClass: 'lg'
            })
            setTimeout(function () {
                $(document).trigger('bubble-hide');
                ChessBoard.board.position(boardFen);
                ChessBoard.game = new window.Chess(boardFen + BLACK_INITIAL_MOVE);
            }, 3000)
        } else {
            $(document).trigger('audio-play', WRONG_ANSWER_AUDIO);
            showMagnus({
                data: `This is not a legal move! You need to end the tour on c3.`,
                position: 'left',
                styleClass: 'md'
            })
            setTimeout(function () {
                $(document).trigger('bubble-hide');
                ChessBoard.board.position(boardFen);
                ChessBoard.game = new window.Chess(boardFen + BLACK_INITIAL_MOVE);
            }, 3000)
        }
    }


    const chessConfig = {
        config: {
            sparePieces: true,
            draggable: true,
            position: position,
            onDragStart: onDragStart,
            onDrop: onDrop,
            onSnapEnd: onSnapEnd
        },
        afterLoad: afterLoad
    }
    return chessConfig;
}

/**
 * @name lesson13Activity3
 * @function
 * @param { config }
 * @description: Knight does a checkmate
 */

export function lesson13Activity3(config) {
    let position = config.position,
        next = config.next,
        finalPosition = config.resultFen,
        count = 2,
        moveSpeed = 1000;

    let afterLoad = function () {
        prepareChessboard(config);
    }

    let onDragStart = function (source, piece, position, orientation) {
        return restrictMove(piece, config.restrictMoveOf);
    }

    let onDrop = function (source, target, piece, newPos, oldPos, orientation) {
        return validateMove(source, target, piece, false);
    }

    var onSnapEnd = function (source, target, piece) {
        let boardFen = ChessBoard.board.fen();
        --count;
        if (boardFen === finalPosition) {
            showMagnus({
                data: `Nice job!`,
                position: 'left',
                styleClass: 'xs'
            });
            loadNextConfiguration(4000, next, true)
        } else if (count > 0) {
            showMagnus({
                data: `That's not a checkmate!`,
                position: 'left',
                styleClass: 'md'
            })
            setTimeout(function () {
                $(document).trigger('bubble-hide');
            }, 3000)
            ChessBoard.board.position(position);
            ChessBoard.game = new window.Chess(position + config.initialMoveOf);
        } else {
            ChessBoard.board.position(position);
            showMagnus({
                data: `The correct move is <b>${config.move}</b>`,
                position: 'left',
                styleClass: 'md'
            })
            setTimeout(function () {
                ChessBoard.board.move(`${config.from}-${config.to}`);
            }, 4000)
            loadNextConfiguration(7000, next, false);
        }
    }


    const chessConfig = {
        config: {
            sparePieces: true,
            draggable: true,
            position: position,
            moveSpeed: moveSpeed,
            onDragStart: onDragStart,
            onDrop: onDrop,
            onSnapEnd: onSnapEnd
        },
        afterLoad: afterLoad
    }
    return chessConfig;
}

/**
 * @name lesson13Activity3
 * @function
 * @param { config }
 * @description: Knight does a checkmate
 */

export function lesson13QA(config) {
    let squares = config.squares;

    let afterLoad = function () {
        prepareChessboard(config);
        $(function () {
            $('.answer').click(function () {
                squares.forEach(element => {
                    $(element).css('border', '1px solid red');
                })
            })
        })
    }
    const chessConfig = {
        config: {
            position: config.position,
        },
        afterLoad: afterLoad
    }
    return chessConfig;
}



// WEBPACK FOOTER //
// ./src/lessons/lesson_13/assignments.js